import { motion } from 'framer-motion'
import featureDocumentos from '../../../../assets/images/doctor-legal/ilustracoes/feature_documentos.png'

export default function Documents({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-[45%] flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6">Acervo Jurídico</span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          Documentos prontos. Sem templates genéricos.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-8">
          <span className="hidden md:inline">
            Termos de consentimento, contratos com clínicas e orientações pré-formatadas — todos revisados por especialistas em direito médico. Nada de template genérico da internet.
          </span>
          <span className="md:hidden">
            Documentos prontos e ajustados por advogados especialistas — sem templates genéricos da internet.
          </span>
        </p>
        <a href="#planos" className="btn-primary hidden lg:inline-flex">
          Garantir minha vaga
        </a>
      </motion.div>

      <div className="w-full lg:w-[55%] flex items-center justify-center order-2">
        <img
          src={featureDocumentos}
          alt="Ilustração de acervo jurídico"
          className="w-full max-w-[400px] sm:max-w-[500px] lg:max-w-none h-auto object-contain"
        />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary w-full justify-center">
          Garantir minha vaga
        </a>
      </div>
    </div>
  )
}
